import React from "react";
import { connect } from "react-redux";
import * as Type from "@interface/index";
import { withRouter } from "react-router-dom";
import * as Components from "./components";
import * as Middleware from "@middlewares/index";
import { Helmet } from "react-helmet";
import { PreloaderPage } from "@components/preloader";

interface PropsInterface extends Type.ComponentInterface {}

interface StateInterface {
  companyType: string;
}

class StandPage extends React.Component<PropsInterface, StateInterface> {
  public constructor(props: PropsInterface) {
    super(props);
    this.state = {
      companyType: "silver",
    };
  }

  public componentDidMount() {
    Middleware.Company.Direction.load();
    Middleware.Stand.Selected.load(Number(this.props.match.params.stand_id));
  }

  public componentWillUnmount() {
    Middleware.Stand.Selected.clear();
  }

  public render() {
    const USE_STAND_MOCK = false;
    const MOCK_STAND = {
      data: {
        id: 3098,
        title:
          "\u0421\u0435\u0440\u0432\u0438\u0441 \u0434\u043b\u044f \u0441\u043e\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043f\u043e\u043a\u0443\u043f\u043e\u043a \u0438 \u043f\u043b\u0430\u0442\u0435\u0436\u0435\u0439 \u043f\u043e \u0432\u0441\u0435\u043c\u0443 \u043c\u0438\u0440\u0443 \u00ab\u041f\u043b\u0430\u0442\u0438 \u043f\u043e \u041c\u0438\u0440\u0443\u00bb",
        type: 1,
        companyImage:
          "https://cdn.profi.travel/uploads/company/logo/6899fe213f602249120213.png",
        offices: [
          {
            id: 4529,
            title:
              "\u0421\u0435\u0440\u0432\u0438\u0441 \u0434\u043b\u044f \u0441\u043e\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043f\u043e\u043a\u0443\u043f\u043e\u043a \u0438 \u043f\u043b\u0430\u0442\u0435\u0436\u0435\u0439 \u043f\u043e \u0432\u0441\u0435\u043c\u0443 \u043c\u0438\u0440\u0443 \u00ab\u041f\u043b\u0430\u0442\u0438 \u043f\u043e \u041c\u0438\u0440\u0443\u00bb",
            address: null,
            phone: "+7 (999) 448-10-24",
            email: "p_belov@platipomiru.com",
            networkingCity: null,
            networkingCountry: null,
            contactPersonName: null,
            contactPersonDescription: null,
          },
        ],
        networkingProfile: {
          facebook: null,
          instagram: null,
          vkontakte: null,
          youtube: null,
          tiktok: null,
          telegram: null,
          creator: 166472,
        },
        website: "platipomiru.com",
        directions: [],
        mainImage:
          "https://cdn.profi.travel/uploads/company_stand/background/68c17a1e09a40961447365.png",
        additionalImage:
          "https://cdn.profi.travel/uploads/company_stand/additional_background/68c17b7c98606629823104.png",
        mainVideoId: null,
        mainVideoPreview: null,
        blocks: [
          {
            type: "users",
            title:
              "\u041f\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043b\u0438 \u043e\u0440\u0433\u0430\u043d\u0438\u0437\u0430\u0446\u0438\u0438",
            data: [
              {
                id: 204155,
                fullName:
                  "\u041f\u0430\u0432\u0435\u043b \u0411\u0435\u043b\u043e\u0432",
                position:
                  "\u0414\u0438\u0440\u0435\u043a\u0442\u043e\u0440 \u043f\u043e \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u044e",
                image:
                  "https://cdn.profi.travel/uploads/profile/image/689dc2f46d6a0882988364.jfif",
                cutaway: null,
              },
            ],
          },
          {
            type: "presentations",
            title:
              "\u041f\u0440\u0435\u0437\u0435\u043d\u0442\u0430\u0446\u0438\u0438",
            data: [],
          },
          {
            type: "pastPresentations",
            title:
              "\u041f\u0440\u043e\u0448\u0435\u0434\u0448\u0438\u0435 \u043f\u0440\u0435\u0437\u0435\u043d\u0442\u0430\u0446\u0438\u0438",
            data: [
              {
                id: 168885,
                type: "webinar",
                title:
                  "\u041e\u043f\u043b\u0430\u0442\u0430 \u0437\u0430 \u0433\u0440\u0430\u043d\u0438\u0446\u0435\u0439 \u0431\u043e\u043b\u044c\u0448\u0435 \u043d\u0435 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0430. \u0421\u0435\u0440\u0432\u0438\u0441 \u043a\u043e\u0442\u043e\u0440\u044b\u0439 \u0432\u0441\u0435\u0433\u0434\u0430 \u043f\u043e\u0434 \u0440\u0443\u043a\u043e\u0439 \u0438 \u0434\u043e\u0441\u0442\u0443\u043f\u0435\u043d \u043a\u0430\u0436\u0434\u043e\u043c\u0443",
                viewsCount: 62,
                participantsCount: 565,
                path: "/events/webinars/show/168885",
                date: "2025-09-11T12:00:00+03:00",
                dateEnd: "2025-09-11T12:30:00+03:00",
                status: 1,
                subscribed: false,
              },
            ],
          },
          {
            type: "about",
            title:
              "\u041e\u0441\u043d\u043e\u0432\u043d\u0430\u044f \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044f",
            data: "\u003Cp\u003EPay People \u0438\u0026nbsp;Trixti Global Limited \u043f\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043b\u044f\u044e\u0442 \u0441\u043e\u0431\u043e\u0439 \u0433\u0440\u0443\u043f\u043f\u0443 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0439, \u0441\u043f\u0435\u0446\u0438\u0430\u043b\u0438\u0437\u0438\u0440\u0443\u044e\u0449\u0438\u0445\u0441\u044f \u043d\u0430\u0026nbsp;\u043f\u0440\u0435\u0434\u043e\u0441\u0442\u0430\u0432\u043b\u0435\u043d\u0438\u0438 \u0438\u043d\u043d\u043e\u0432\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0445 \u0444\u0438\u043d\u0430\u043d\u0441\u043e\u0432\u044b\u0445 \u0440\u0435\u0448\u0435\u043d\u0438\u0439 \u0434\u043b\u044f \u043e\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043b\u0435\u043d\u0438\u044f \u043c\u0435\u0436\u0434\u0443\u043d\u0430\u0440\u043e\u0434\u043d\u044b\u0445 \u043f\u043b\u0430\u0442\u0435\u0436\u0435\u0439. \u0418\u0445\u0026nbsp;\u0441\u0435\u0440\u0432\u0438\u0441 \u0434\u0430\u0451\u0442 \u0432\u043e\u0437\u043c\u043e\u0436\u043d\u043e\u0441\u0442\u044c \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f\u043c \u0441\u043e\u0432\u0435\u0440\u0448\u0430\u0442\u044c \u043f\u043e\u043a\u0443\u043f\u043a\u0438 \u0438\u0026nbsp;\u043e\u043f\u043b\u0430\u0447\u0438\u0432\u0430\u0442\u044c \u0443\u0441\u043b\u0443\u0433\u0438 \u0432\u0026nbsp;\u0437\u0430\u0440\u0443\u0431\u0435\u0436\u043d\u044b\u0445 \u043e\u043d\u043b\u0430\u0439\u043d-\u043c\u0430\u0433\u0430\u0437\u0438\u043d\u0430\u0445 \u0438\u0026nbsp;\u0441\u0435\u0440\u0432\u0438\u0441\u0430\u0445.\u003C/p\u003E\r\n\r\n\u003Cp\u003E\u0413\u0440\u0443\u043f\u043f\u0430 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0439 \u0438\u043c\u0435\u0435\u0442 \u043f\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043b\u044c\u0441\u0442\u0432\u0430 \u043a\u0430\u043a \u0432\u0026nbsp;\u0420\u043e\u0441\u0441\u0438\u0439\u0441\u043a\u043e\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438, \u0442\u0430\u043a \u0438\u0026nbsp;\u0437\u0430\u0026nbsp;\u0440\u0443\u0431\u0435\u0436\u043e\u043c, \u043e\u0445\u0432\u0430\u0442\u044b\u0432\u0430\u044f \u0431\u043e\u043b\u0435\u0435 160 \u0441\u0442\u0440\u0430\u043d \u043c\u0438\u0440\u0430.\u003C/p\u003E\r\n\r\n\u003Cp\u003E\u041e\u0441\u043d\u043e\u0432\u043d\u0430\u044f \u043c\u0438\u0441\u0441\u0438\u044f \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438 \u0437\u0430\u043a\u043b\u044e\u0447\u0430\u0435\u0442\u0441\u044f \u0432\u0026nbsp;\u043f\u043e\u043c\u043e\u0449\u0438 \u043e\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0435\u043d\u043d\u044b\u043c \u0442\u0443\u0440\u0438\u0441\u0442\u0430\u043c \u0438\u0026nbsp;\u0442\u0443\u0440\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043a\u0438\u043c \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u044f\u043c \u0432\u0026nbsp;\u043f\u0440\u0435\u043e\u0434\u043e\u043b\u0435\u043d\u0438\u0438 \u0438\u0441\u043a\u0443\u0441\u0441\u0442\u0432\u0435\u043d\u043d\u043e \u0441\u043e\u0437\u0434\u0430\u043d\u043d\u044b\u0445 \u0431\u0430\u0440\u044c\u0435\u0440\u043e\u0432, \u0432\u043a\u043b\u044e\u0447\u0430\u044f \u0441\u0430\u043d\u043a\u0446\u0438\u0438 \u0432\u0026nbsp;\u043e\u0442\u043d\u043e\u0448\u0435\u043d\u0438\u0438 \u0440\u0435\u0437\u0438\u0434\u0435\u043d\u0442\u043e\u0432 \u0420\u0424. \u041a\u043e\u043c\u043f\u0430\u043d\u0438\u044f \u0441\u0442\u0440\u0435\u043c\u0438\u0442\u0441\u044f \u043e\u0431\u0435\u0441\u043f\u0435\u0447\u0438\u0442\u044c \u0431\u0435\u0441\u043f\u0440\u0435\u043f\u044f\u0442\u0441\u0442\u0432\u0435\u043d\u043d\u043e\u0435 \u0441\u043e\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u0435 \u043f\u043e\u043a\u0443\u043f\u043e\u043a \u0438\u0026nbsp;\u043e\u043f\u043b\u0430\u0442\u0443 \u0441\u0435\u0440\u0432\u0438\u0441\u043e\u0432 \u0437\u0430\u0026nbsp;\u0440\u0443\u0431\u0435\u0436\u043e\u043c, \u0432\u043e\u0437\u0432\u0440\u0430\u0449\u0430\u044f \u043a\u043e\u043c\u0444\u043e\u0440\u0442 \u0438\u0026nbsp;\u043f\u043e\u043b\u043e\u0436\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u0442\u0443\u0440\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043a\u0438\u0439 \u043e\u043f\u044b\u0442, \u0430\u0026nbsp;\u0442\u0430\u043a\u0436\u0435 \u043c\u0438\u043d\u0438\u043c\u0438\u0437\u0438\u0440\u0443\u044f \u0440\u0438\u0441\u043a\u0438, \u0441\u0432\u044f\u0437\u0430\u043d\u043d\u044b\u0435 \u0441\u0026nbsp;\u043c\u043e\u0448\u0435\u043d\u043d\u0438\u0447\u0435\u0441\u0442\u0432\u043e\u043c \u0432\u0026nbsp;\u043c\u0435\u0436\u0434\u0443\u043d\u0430\u0440\u043e\u0434\u043d\u043e\u043c \u0444\u0438\u043d\u0430\u043d\u0441\u043e\u0432\u043e\u043c \u043a\u043e\u043d\u0442\u0443\u0440\u0435. \u041a\u0440\u043e\u043c\u0435 \u0442\u043e\u0433\u043e, \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u044f \u043f\u0440\u0435\u0434\u043e\u0441\u0442\u0430\u0432\u043b\u044f\u0435\u0442 \u043f\u043e\u0442\u0435\u043d\u0446\u0438\u0430\u043b\u044c\u043d\u044b\u043c \u043f\u0430\u0440\u0442\u043d\u0451\u0440\u0430\u043c \u0432\u0026nbsp;\u0441\u0444\u0435\u0440\u0435 \u0442\u0443\u0440\u0438\u0437\u043c\u0430 \u0432\u043e\u0437\u043c\u043e\u0436\u043d\u043e\u0441\u0442\u044c \u0434\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u044c \u0441\u0432\u043e\u0438 \u043f\u0440\u043e\u0434\u0443\u043a\u0442\u044b, \u0443\u0432\u0435\u043b\u0438\u0447\u0438\u0432\u0430\u044f \u0441\u0440\u0435\u0434\u043d\u0438\u0439 \u0447\u0435\u043a.\u003C/p\u003E\r\n\r\n\u003Cp\u003E\u0421\u0435\u0440\u0432\u0438\u0441 \u043f\u0440\u0435\u0434\u043e\u0441\u0442\u0430\u0432\u043b\u044f\u0435\u0442 \u0432\u043e\u0437\u043c\u043e\u0436\u043d\u043e\u0441\u0442\u044c \u043e\u0442\u043a\u0440\u044b\u0442\u0438\u044f \u043a\u0430\u0440\u0442\u044b, \u043a\u043e\u0442\u043e\u0440\u0443\u044e \u043c\u043e\u0436\u043d\u043e \u043c\u043e\u043c\u0435\u043d\u0442\u0430\u043b\u044c\u043d\u043e \u043f\u043e\u043f\u043e\u043b\u043d\u044f\u0442\u044c \u0440\u0443\u0431\u043b\u044f\u043c\u0438 \u0441\u0026nbsp;\u043a\u043e\u043d\u0432\u0435\u0440\u0442\u0430\u0446\u0438\u0435\u0439 \u0432\u0026nbsp;\u0434\u043e\u043b\u043b\u0430\u0440\u044b \u0434\u043b\u044f \u0441\u043e\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043f\u043e\u043a\u0443\u043f\u043e\u043a.\u003C/p\u003E\r\n\r\n\u003Cp\u003E\u041f\u0430\u0440\u0442\u043d\u0451\u0440\u0441\u0442\u0432\u043e \u0441\u0026nbsp;\u0422-\u0411\u0430\u043d\u043a\u043e\u043c \u043f\u043e\u0437\u0432\u043e\u043b\u044f\u0435\u0442 \u0432\u044b\u0441\u0442\u0440\u043e\u0438\u0442\u044c \u0441\u0442\u0440\u0443\u043a\u0442\u0443\u0440\u0443 \u043f\u043e\u043f\u043e\u043b\u043d\u0435\u043d\u0438\u044f \u043a\u0430\u0440\u0442 \u043a\u0440\u0435\u0434\u0438\u0442\u043d\u044b\u043c\u0438 \u043f\u0440\u043e\u0434\u0443\u043a\u0442\u0430\u043c\u0438 \u0431\u0430\u043d\u043a\u0430, \u0447\u0442\u043e \u0440\u0430\u0441\u0448\u0438\u0440\u044f\u0435\u0442 \u0432\u043e\u0437\u043c\u043e\u0436\u043d\u043e\u0441\u0442\u0438 \u043f\u043e\u043a\u0443\u043f\u043e\u043a \u0443\u0026nbsp;\u043f\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043b\u0435\u0439 \u0442\u0443\u0440\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043a\u043e\u0439 \u043e\u0442\u0440\u0430\u0441\u043b\u0438 \u0438\u0437\u0026nbsp;\u043a\u0430\u0442\u0435\u0433\u043e\u0440\u0438\u0438 \u0434\u043e\u043f\u043e\u043b\u043d\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0445 \u0443\u0441\u043b\u0443\u0433.\u003C/p\u003E\r\n\r\n\u003Cp\u003E\u041a\u043e\u043c\u043f\u0430\u043d\u0438\u044f \u0432\u0445\u043e\u0434\u0438\u0442 \u0432\u0026nbsp;\u0442\u0440\u043e\u0439\u043a\u0443 \u043a\u0440\u0443\u043f\u043d\u0435\u0439\u0448\u0438\u0445 \u043f\u043b\u0430\u0442\u0451\u0436\u043d\u044b\u0445 \u0430\u0433\u0435\u043d\u0442\u043e\u0432, \u043e\u043a\u0430\u0437\u044b\u0432\u0430\u044e\u0449\u0438\u0445 \u0443\u0441\u043b\u0443\u0433\u0438 \u0442\u0440\u0430\u043d\u0441\u0433\u0440\u0430\u043d\u0438\u0447\u043d\u044b\u0445 \u043f\u043b\u0430\u0442\u0435\u0436\u0435\u0439 \u0434\u043b\u044f \u043a\u0440\u0443\u043f\u043d\u044b\u0445 \u0431\u0430\u043d\u043a\u043e\u0432, \u0438\u0026nbsp;\u044f\u0432\u043b\u044f\u0435\u0442\u0441\u044f \u043f\u043e\u043b\u043d\u043e\u0441\u0442\u044c\u044e \u043b\u0435\u0433\u0430\u043b\u044c\u043d\u043e\u0439 \u043e\u0440\u0433\u0430\u043d\u0438\u0437\u0430\u0446\u0438\u0435\u0439.\u003C/p\u003E\r\n\r\n\u003Cp\u003E\u0420\u0435\u0437\u0438\u0434\u0435\u043d\u0442\u044b \u0421\u043a\u043e\u043b\u043a\u043e\u0432\u043e, \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u044f \u0437\u0430\u043d\u0438\u043c\u0430\u0435\u0442 \u0437\u043d\u0430\u0447\u0438\u043c\u043e\u0435 \u043c\u0435\u0441\u0442\u043e \u0432\u0026nbsp;\u043e\u0431\u043b\u0430\u0441\u0442\u0438 Fintech, \u043f\u0440\u0435\u0434\u043b\u0430\u0433\u0430\u044f \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0435\u0440\u0432\u0438\u0441\u044b:\u003C/p\u003E\r\n\r\n\u003Cul\u003E\r\n\t\u003Cli\u003EtaxiCRM\u0026nbsp;\u0026mdash; \u0441\u0435\u0440\u0432\u0438\u0441 \u0430\u0432\u0442\u043e\u043c\u0430\u0442\u0438\u0437\u0430\u0446\u0438\u0438 \u0442\u0430\u043a\u0441\u043e\u043f\u0430\u0440\u043a\u043e\u0432;\u003C/li\u003E\r\n\t\u003Cli\u003EPayPeople\u0026nbsp;\u0026mdash; \u043f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u0434\u043b\u044f \u0432\u044b\u043f\u043b\u0430\u0442\u044b \u0437\u0430\u0440\u0430\u0431\u043e\u0442\u043d\u043e\u0439 \u043f\u043b\u0430\u0442\u044b \u0441\u043e\u0442\u0440\u0443\u0434\u043d\u0438\u043a\u0430\u043c \u043f\u043e\u0026nbsp;\u0437\u0430\u043f\u0440\u043e\u0441\u0443;\u003C/li\u003E\r\n\t\u003Cli\u003ESwiftPeople\u0026nbsp;\u0026mdash; \u043f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u0434\u043b\u044f \u0442\u0440\u0430\u043d\u0441\u0433\u0440\u0430\u043d\u0438\u0447\u043d\u044b\u0445 \u043f\u043b\u0430\u0442\u0435\u0436\u0435\u0439, \u043e\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043b\u044f\u044e\u0449\u0430\u044f \u043f\u043b\u0430\u0442\u0435\u0436\u0438 \u0437\u0430\u0026nbsp;\u0433\u0440\u0430\u043d\u0438\u0446\u0443 \u0434\u043b\u044f \u0431\u0430\u043d\u043a\u043e\u0432\u0026nbsp;\u0420\u0424 (\u0421\u0431\u0435\u0440, \u0422-\u0411\u0430\u043d\u043a, \u0421\u043e\u0432\u043a\u043e\u043c\u0431\u0430\u043d\u043a, \u0422\u043e\u0447\u043a\u0430 \u0438\u0026nbsp;\u0434\u0440\u0443\u0433\u0438\u0435);\u003C/li\u003E\r\n\t\u003Cli\u003E\u0026laquo;\u041f\u043b\u0430\u0442\u0438 \u043f\u043e\u0026nbsp;\u043c\u0438\u0440\u0443\u0026raquo;\u0026nbsp;\u0026mdash; \u0432\u0438\u0440\u0442\u0443\u0430\u043b\u044c\u043d\u044b\u0435 \u043a\u0430\u0440\u0442\u044b \u0434\u043b\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0437\u0430\u0026nbsp;\u0433\u0440\u0430\u043d\u0438\u0446\u0435\u0439.\u003C/li\u003E\r\n\u003C/ul\u003E\r\n\r\n\u003Cp\u003E\u041a\u043e\u043c\u043f\u0430\u043d\u0438\u044f \u0430\u043a\u0442\u0438\u0432\u043d\u043e \u0440\u0430\u0437\u0440\u0430\u0431\u0430\u0442\u044b\u0432\u0430\u0435\u0442 \u043d\u043e\u0432\u044b\u0435 \u043f\u0440\u043e\u0434\u0443\u043a\u0442\u044b, \u043a\u043e\u0442\u043e\u0440\u044b\u0435 \u0431\u0443\u0434\u0443\u0442 \u0438\u043d\u0442\u0435\u0440\u0435\u0441\u043d\u044b \u043f\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u0438\u0442\u0435\u043b\u044f\u043c \u0442\u0443\u0440\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043a\u043e\u0439 \u043e\u0442\u0440\u0430\u0441\u043b\u0438 \u0438\u0026nbsp;\u043f\u043e\u043c\u043e\u0433\u0443\u0442 \u043f\u0440\u0435\u043e\u0434\u043e\u043b\u0435\u0442\u044c \u0441\u043b\u043e\u0436\u043d\u043e\u0441\u0442\u0438, \u0432\u043e\u0437\u043d\u0438\u043a\u0448\u0438\u0435 \u0432\u0026nbsp;\u0443\u0441\u043b\u043e\u0432\u0438\u044f\u0445 \u0441\u0430\u043d\u043a\u0446\u0438\u0439, \u0441\u043f\u043e\u0441\u043e\u0431\u0441\u0442\u0432\u0443\u044f \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u044e \u0442\u0443\u0440\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043a\u043e\u0439 \u043e\u0442\u0440\u0430\u0441\u043b\u0438 \u0432\u0026nbsp;\u0420\u0424.\u003C/p\u003E",
          },
          {
            type: "partners",
            title:
              "\u041a\u043e\u043c\u043f\u0430\u043d\u0438\u0438-\u043f\u0430\u0440\u0442\u043d\u0435\u0440\u044b",
            data: [],
          },
          {
            type: "catalogs",
            title: "\u041a\u0430\u0442\u0430\u043b\u043e\u0433\u0438",
            data: [
              {
                title:
                  "\u0422\u0443\u0440\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043a\u0430\u044f \u043f\u0440\u0435\u0437\u0435\u043d\u0442\u0430\u0446\u0438\u044f Pay People",
                path: "/companies/download/catalog/2833",
              },
            ],
          },
          {
            type: "photo",
            title: "\u0424\u043e\u0442\u043e",
            data: [],
          },
          {
            type: "video",
            title: "\u0412\u0438\u0434\u0435\u043e",
            data: [],
          },
        ],
      },
    } as const;

    const storeAny = (this.props as any).Store as any;
    if (USE_STAND_MOCK) {
      if (
        !storeAny?.Stand?.Selected?.data ||
        (typeof storeAny.Stand.Selected.data === "object" &&
          Object.keys(storeAny.Stand.Selected.data).length === 0)
      ) {
        if (!storeAny.Stand) {
          storeAny.Stand = {};
        }
        if (!storeAny.Stand.Selected) {
          storeAny.Stand.Selected = {};
        }
        storeAny.Stand.Selected.data = (MOCK_STAND as any).data;
      }
    }

    const standSelectedData = storeAny.Stand.Selected?.data;
    const workshopData = (storeAny?.Main as any)?.Workshop?.data;
    if (
      !standSelectedData ||
      (typeof standSelectedData === "object" &&
        Object.keys(standSelectedData).length === 0)
    ) {
      return <PreloaderPage />;
    }

    return (
      <>
        <Helmet
          title={`${
            standSelectedData?.title ? standSelectedData?.title : "Стенд"
          } | ${workshopData?.title}`}
          meta={[
            {
              name: "description",
              content: `Стенд компании «${standSelectedData?.title}» на онлайн-выставке`,
            },
          ]}
        />
        <div
          className={`stand ${
            standSelectedData?.type === 2 || standSelectedData?.type === 3
              ? "stand--general"
              : ""
          } ${
            standSelectedData?.mainImage &&
            (standSelectedData?.type === 2 || standSelectedData?.type === 3)
              ? ""
              : "stand--no-desktop"
          } ${
            standSelectedData?.additionalImage &&
            (standSelectedData?.type === 2 || standSelectedData?.type === 3)
              ? ""
              : "stand--no-mobile"
          }`}
        >
          {standSelectedData?.type === 2 || standSelectedData?.type === 3 ? (
            <Components.Header />
          ) : (
            ""
          )}

          <div className="stand__grid">
            <div className="stand__header">
              <Components.Title />
              <Components.Menu />
            </div>

            <div className="stand__body">
              <div className="stand__left-col">
                {standSelectedData?.blocks?.map((item: any, index: number) => {
                  switch (item.type) {
                    case "presentations":
                      return (
                        <Components.Schedule
                          key={index}
                          title={item.title}
                          data={item.data}
                        />
                      );
                    case "pastPresentations":
                      return (
                        <Components.Schedule
                          key={index}
                          title={item.title}
                          data={item.data}
                        />
                      );
                    case "about":
                      return (
                        <Components.About
                          key={index}
                          title={item.title}
                          data={item.data}
                        />
                      );
                    case "partners":
                      return (
                        <Components.Partners
                          key={index}
                          title={item.title}
                          data={item.data}
                        />
                      );
                    case "catalogs":
                      return (
                        <Components.Cats
                          key={index}
                          title={item.title}
                          data={item.data}
                        />
                      );
                    case "photo":
                      return (
                        <Components.Photo
                          key={index}
                          title={item.title}
                          data={item.data}
                        />
                      );
                    case "video":
                      return (
                        <Components.Video
                          key={index}
                          title={item.title}
                          data={item.data}
                        />
                      );
                    case "partnersSites":
                      return (
                        <Components.PartnersSites
                          key={index}
                          title={item.title}
                          data={item.data}
                        />
                      );
                    case "guide":
                      return (
                        <Components.Guide
                          key={index}
                          title={item.title}
                          data={item.data}
                        />
                      );
                    default:
                      break;
                  }
                })}
                {/* <Components.Partners
                  key={1}
                  title="Компании-партнеры в нетворкинге"
                  data={[
                    {
                      id: 1,
                      logo: null,
                      title: "Tokisaki Kurumi",
                      users: [{ image: null, fullName: "1" }],
                    },
                    {
                      id: 2,
                      logo: null,
                      title: "Tokisaki Kurumi",
                      users: [{ image: null, fullName: "1" }],
                    },
                    {
                      id: 3,
                      logo: null,
                      title:
                        "Tokisaki Kurumi Tokisaki Kurumi Tokisaki Kurumi Tokisaki Kurumi Tokisaki Kurumi Tokisaki Kurumi",
                      users: [{ image: null, fullName: "1" }],
                    },
                    {
                      id: 4,
                      logo: null,
                      title: "Tokisaki Kurumi",
                      users: [{ image: null, fullName: "1" }],
                    },
                    {
                      id: 5,
                      logo: null,
                      title: "Tokisaki Kurumi",
                      users: [{ image: null, fullName: "1" }],
                    },
                    {
                      id: 6,
                      logo: null,
                      title: "Tokisaki Kurumi",
                      users: [{ image: null, fullName: "1" }],
                    },
                  ]}
                /> */}
                {/* <Components.PartnersSites
                  key={124}
                  title="Сайты компаний-партнеров"
                  data={[
                    {
                      image:
                        "https://cdn.profi.travel/storage/profi-travel/uploads/CompanyStandPartner/61237c1b8f12f820111731.png",
                      title: "Туристическая компания «АРГО»",
                      url: "https://tourargo.ru",
                    },
                    {
                      image:
                        "https://cdn.profi.travel/storage/profi-travel/uploads/CompanyStandPartner/61237c1b8f12f820111731.png",
                      title: "Туристическая компания «АРГО»",
                      url: "https://tourargo.ru",
                    },
                  ]}
                /> */}

                {/* <Components.Schedule
                  key={123}
                  title={"Презентации"}
                  data={[
                    {
                      date: "10.10.2021 10:00:00",
                      path: "/asdad/asdads",
                      title: "Hello world",
                      viewsCount: 10,
                      participantsCount: 123,
                    },
                  ]}
                /> */}

                {/* <Components.Questions>
                  <Components.Answer />
                  <Components.Answer companyAdmin={true} />
                </Components.Questions> */}
                {/* <Components.Request /> */}

                <Components.Contacts />
              </div>
              <div className="stand__right-col">
                {standSelectedData?.blocks?.map((item: any, index: number) => {
                  if (item.type === "users") {
                    return (
                      <Components.Members
                        key={index}
                        title={item.title}
                        data={item.data}
                      />
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: (action: any) => void) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(StandPage)
);
